import { AccordionHeader, AccordionItem, AccordionPanel, Menu, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Link } from 'react-router';
import { useStores } from '../../../common/hooks';
import { RoutePaths } from '../../../route-paths';
import './AdminMenu.scss';
import { useMenuStyles } from './use-menu-styles';

interface Props {
  renderInAppDrawer?: {
    onMenuItemClick: () => void;
  };
}

const TITLE = 'Admin';

const AdminMenu: React.FC<Props> = ({ renderInAppDrawer }) => {
  const {
    userStore,
  } = useStores();
  const [isOpenMenuPopover, setIsOpenMenuPopover] = useState(false);
  const classes = useMenuStyles();

  const renderMenuItemLink = (displayName: string, to: string,) => (
    <Link
      role='menuitem'
      to={to}
      className={classes.menuItem}
      onClick={() => {
        if (renderInAppDrawer) {
          renderInAppDrawer.onMenuItemClick();
          return;
        }
        setIsOpenMenuPopover(false);
      }}
    >
      {displayName}
    </Link>
  );

  const renderMenuList = () => (
    <>
      {
        userStore.isAdmin && (
          <>
            {renderMenuItemLink('Manage award details', RoutePaths.EditAwardDetail)}
            {renderMenuItemLink('Manage award list', RoutePaths.ManageAwardList)}
            {renderMenuItemLink('Edit dates', RoutePaths.ProgramDates)}
            {renderMenuItemLink('Edit regional / country leads', RoutePaths.EditRegional)}
            {renderMenuItemLink('User resources', RoutePaths.UserResources)}
            {renderMenuItemLink('Operations', RoutePaths.OperationDashboard)}
            {renderMenuItemLink('Email', RoutePaths.Email)}
            {renderMenuItemLink('Notifications', RoutePaths.Notifications)}
            {renderMenuItemLink('Winner requirements', RoutePaths.WinnerRequirement)}
            {renderMenuItemLink('View all programs', RoutePaths.Programs)}
          </>
        )
      }
      {
        userStore.isRegionLead && renderMenuItemLink('Edit regional / country leads', RoutePaths.EditRegional)
      }
    </>
  );

  if (renderInAppDrawer) return (
    <AccordionItem
      value='admin-menu'
    >
      <AccordionHeader expandIconPosition='end'>{TITLE}</AccordionHeader>
      <AccordionPanel>
        {renderMenuList()}
      </AccordionPanel>
    </AccordionItem>
  );

  return (
    <div
      className='admin-menu'
    >
      <Menu
        open={isOpenMenuPopover}
        onOpenChange={() => setIsOpenMenuPopover(!isOpenMenuPopover)}
        positioning={{
          autoSize: true,
          offset: { mainAxis: 19 }
        }}
      >
        <MenuTrigger>
          <button
            onClick={() => setIsOpenMenuPopover(!isOpenMenuPopover)}
          >
            {TITLE}
          </button>
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            {renderMenuList()}
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};

export default observer(AdminMenu);
